import React from 'react'
import {
	Drawer, List, Row, Space, Tag, Typography, Button
} from 'antd'
import { CloseOutlined, ExclamationCircleOutlined, CheckCircleOutlined } from '@ant-design/icons'

export type ComplaintStatus =
	| 'unjustified'
	| 'justified_unresolved'
	| 'justified_resolved_by_cleaner'
	| 'justified_resolved_by_manager'

export interface IComplaintListItem {
	id: number
	status: ComplaintStatus
	createdAt: string
	note?: string | null
	job?: { id: number; address: string } | null
	finishID?: number | null
}

interface Props {
	items: IComplaintListItem[]
	open: boolean
	onClose: () => void
	onOpenComplaint: (id: number) => void
}

const statusToLabel: Record<ComplaintStatus, string> = {
	unjustified: 'Neopodložené',
	justified_unresolved: 'Oprávnené – nevybavené',
	justified_resolved_by_cleaner: 'Oprávnené – vyriešené upratovačkou',
	justified_resolved_by_manager: 'Oprávnené – vyriešené manažérom'
}

const statusToTag: Record<ComplaintStatus, { color: string; icon?: React.ReactNode }> = {
	unjustified: { color: 'default', icon: <ExclamationCircleOutlined /> },
	justified_unresolved: { color: 'volcano', icon: <ExclamationCircleOutlined /> },
	justified_resolved_by_cleaner: { color: 'green', icon: <CheckCircleOutlined /> },
	justified_resolved_by_manager: { color: 'blue', icon: <CheckCircleOutlined /> }
}

const ComplaintsDetailDrawer: React.FC<Props> = ({
	items, open, onClose, onOpenComplaint
}) => (
	<Drawer
		title={
			<Row justify="space-between" align="middle">
				<Space>
					<CloseOutlined style={{ color: '#aaa' }} onClick={onClose} />
					<Typography.Text strong>Sťažnosti – detail</Typography.Text>
				</Space>
			</Row>
		}
		width={900}
		visible={open}
		onClose={onClose}
		closeIcon={null}
	>
		<List
			itemLayout="vertical"
			dataSource={items}
			renderItem={(item) => {
				const tagConf = statusToTag[item.status]
				return (
					<List.Item key={item.id}>
						<Row justify="space-between" align="middle">
							<Space wrap>
								<Tag icon={tagConf.icon} color={tagConf.color}>
									{statusToLabel[item.status]}
								</Tag>
								<Typography.Text type="secondary">{item.createdAt}</Typography.Text>
								{item.job?.address && <Tag color="blue">{item.job.address}</Tag>}
								{item.finishID ? <Tag>Finish ID: {item.finishID}</Tag> : null}
							</Space>
							<Button type="link" onClick={() => onOpenComplaint(item.id)}>
									Otvoriť detail
							</Button>
						</Row>

						{item.note && (
							<Typography.Paragraph style={{ marginTop: 8 }}>
								{item.note}
							</Typography.Paragraph>
						)}
					</List.Item>
				)
			}}
		/>
	</Drawer>
)

export default ComplaintsDetailDrawer
